(function () {
  'use strict';

  const node = document.getElementById("LSCustomDragonAssConfig");
  if (!node) return;

  let config;
  try {
    config = JSON.parse(node.textContent || '{}');
  } catch (error) {
    console.error('[Love Smiths] Invalid builder configuration:', error);
    return;
  }

  if (!config || !config.sectionId) return;

document.addEventListener("DOMContentLoaded", function () {
    const strings = window.assCustomizerStrings || {};

    /* =========================
       GALLERY
    ========================= */
    const thumbnails = document.querySelectorAll(`#MainProduct-${config.sectionId} .thumbnail`);
    const mainBanner = document.getElementById(`main-banner-${config.sectionId}`);

    function swapMainSrc(newSrc) {
      if (!mainBanner || !newSrc) return;
      mainBanner.classList.add("is-fading");
      const img = new Image();
      img.onload = () => {
        mainBanner.src = newSrc;
        mainBanner.srcset = newSrc;
        mainBanner.removeAttribute("sizes");
        requestAnimationFrame(() => mainBanner.classList.remove("is-fading"));
      };
      img.onerror = () => mainBanner.classList.remove("is-fading");
      img.src = newSrc;
    }

    thumbnails.forEach(t => {
      t.addEventListener("click", function () {
        thumbnails.forEach(x => x.classList.remove("selected"));
        this.classList.add("selected");
        swapMainSrc(this.getAttribute("data-large") || this.getAttribute("src"));
      });
    });

    /* --- Mobile swipe to change main image --- */
    (function () {
      if (!mainBanner) return;

      const thumbs = Array.from(document.querySelectorAll(`#MainProduct-${config.sectionId} .thumbnail`));
      if (!thumbs.length) return;

      let currentIndex = Math.max(0, thumbs.findIndex(el => el.classList.contains("selected")));
      if (currentIndex === -1) currentIndex = 0;

      let startX = 0, startY = 0, swiping = false;

      function goTo(idx) {
        currentIndex = (idx + thumbs.length) % thumbs.length;
        const t = thumbs[currentIndex];
        thumbs.forEach(x => x.classList.remove("selected"));
        t.classList.add("selected");
        const newSrc = t.getAttribute("data-large") || t.getAttribute("src");
        swapMainSrc(newSrc);
      }

      mainBanner.addEventListener("touchstart", (e) => {
        if (!e.touches || !e.touches.length) return;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        swiping = true;
      }, { passive: true });

      mainBanner.addEventListener("touchmove", (e) => {
        if (!swiping) return;
        const dx = e.touches[0].clientX - startX;
        const dy = e.touches[0].clientY - startY;

        if (Math.abs(dx) > 30 && Math.abs(dx) > Math.abs(dy)) {
          e.preventDefault();
        }
      }, { passive: false });

      mainBanner.addEventListener("touchend", (e) => {
        if (!swiping) return;
        swiping = false;

        const dx = e.changedTouches[0].clientX - startX;
        const dy = e.changedTouches[0].clientY - startY;

        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
          if (dx < 0) goTo(currentIndex + 1);
          else goTo(currentIndex - 1);
        }
      });
    })();

    /* =========================
       FORM
    ========================= */
    const form = document.getElementById(`product-form-${config.sectionId}`);
    const hiddenInput = form.querySelector('input[name="id"]');
const addToCartBtn = document.getElementById(`add-to-cart-${config.sectionId}`);
const hint = document.getElementById(`selection-hint-${config.sectionId}`);
const defaultHintText = hint ? hint.textContent.trim() : "";
const instructionEl = document.getElementById(`preview-instructions-${config.sectionId}`);
const priceEl = document.getElementById(`sticky-cart-price-${config.sectionId}`);
const previewEl = document.getElementById("live-preview");
const previewFrame = document.getElementById("sticky-preview-frame");

    const propC1 = document.getElementById(`prop-colour-1-${config.sectionId}`);
    const propC2 = document.getElementById(`prop-colour-2-${config.sectionId}`);
    const propC3 = document.getElementById(`prop-colour-3-${config.sectionId}`);
    const propPenisColour = document.getElementById(`prop-penis-colour-${config.sectionId}`);
    const propPenisOption = document.getElementById(`prop-penis-option-${config.sectionId}`);

    const mainBodySet = document.getElementById(`main-body-set-${config.sectionId}`);
    const penisOptionFrame = document.getElementById(`penis-option-frame-${config.sectionId}`);
    const penisSet = document.getElementById(`penis-set-${config.sectionId}`);
    const penisBodyChoiceFrame = document.getElementById(`penis-body-choice-frame-${config.sectionId}`);
    const penisBodyChoiceButtons = document.getElementById(`penis-body-choice-buttons-${config.sectionId}`);
    const swatchSource = document.getElementById(`swatch-source-${config.sectionId}`);

    const variants = Array.isArray(config.variants) ? config.variants : [];
    const totalOptions = config.optionCount;
    const optionBtns = form.querySelectorAll('.option-btn[data-variant="true"]');

function setCartVisibility(showButton, hintText = defaultHintText) {
  if (addToCartBtn) {
    addToCartBtn.style.visibility = showButton ? "visible" : "hidden";
    addToCartBtn.style.pointerEvents = showButton ? "auto" : "none";
  }

  if (hint) {
    hint.style.display = showButton ? "none" : "block";
    hint.textContent = hintText;
  }
}
    function normalizeBooleanValue(value) {
      const lower = String(value || "").trim().toLowerCase();
      if (["yes", "oui", "sí", "si", "ja", "はい"].includes(lower)) return "yes";
      if (["no", "non", "nein", "いいえ"].includes(lower)) return "no";
      return lower;
    }

    function hydrateSwatches(root) {
      root.querySelectorAll(".swatch").forEach(el => {
        const img = el.querySelector("img");
        const name =
          el.dataset.colourName ||
          (img ? img.alt : "") ||
          (el.textContent || "").trim();

        if (name && !el.dataset.colourName) {
          el.dataset.colourName = name;
        }

        el.setAttribute("role", "button");
        if (!el.hasAttribute("aria-pressed")) {
          el.setAttribute("aria-pressed", "false");
        }
      });
    }

    function populateSwatchSet(setEl) {
      const row = setEl.querySelector(".swatch-row");
      if (!row || !swatchSource) return;

      row.innerHTML = "";

      const groups = swatchSource.querySelector(".swatch-groups");
      if (groups) {
        row.innerHTML = groups.innerHTML;
        hydrateSwatches(setEl);
        return;
      }

      const subCats = swatchSource.querySelectorAll(".sub-swatch-category");
      if (subCats.length) {
        subCats.forEach(cat => {
          row.appendChild(cat.cloneNode(true));
        });
        hydrateSwatches(setEl);
        return;
      }

      const swatches = swatchSource.querySelectorAll(".swatch");
      if (swatches.length) {
        swatches.forEach(sw => {
          row.appendChild(sw.cloneNode(true));
        });
        hydrateSwatches(setEl);
      }
    }

    populateSwatchSet(mainBodySet);
    populateSwatchSet(penisSet);

    function getSelectedSwatches(setEl) {
      return Array.from(setEl.querySelectorAll(".swatch.active"));
    }

    function getSwatchName(sw) {
      if (!sw) return "";
      return (
        sw.dataset.colourName ||
        sw.querySelector("img")?.alt ||
        (sw.textContent || "").trim()
      );
    }

    function clearSwatchSet(setEl) {
      setEl.querySelectorAll(".swatch.active").forEach(sw => {
        sw.classList.remove("active");
        sw.setAttribute("aria-pressed", "false");
      });
    }

    function getSelectedVariantOptions() {
      const selected = new Array(totalOptions).fill("");

      optionBtns.forEach(btn => {
        if (!btn.classList.contains("active")) return;
        const idx = Number(btn.dataset.optionIndex);
        if (Number.isNaN(idx)) return;
        selected[idx] = btn.dataset.value || "";
      });

      return selected;
    }

    function allVariantOptionsChosen(selected) {
      return selected.length === totalOptions && selected.every(v => String(v).trim() !== "");
    }

    function findMatchingVariantExact(selected) {
      return variants.find(v => {
        return v.options.every((opt, i) => {
          return normalizeBooleanValue(opt) === normalizeBooleanValue(selected[i]);
        });
      });
    }

    function getActiveOptionValue(kind) {
      const btn = form.querySelector(`.option-btn[data-option-kind="${kind}"].active`);
      return btn ? normalizeBooleanValue(btn.dataset.value) : "";
    }

    function mainBodyDone() {
      return getSelectedSwatches(mainBodySet).length === 3;
    }

    function clearPenisBodyChoice() {
      if (!penisBodyChoiceButtons) return;
      penisBodyChoiceButtons.innerHTML = "";
    }

    function getSelectedPenisBodyChoiceButton() {
      return penisBodyChoiceButtons
        ? penisBodyChoiceButtons.querySelector(".option-btn.active")
        : null;
    }

    function getSelectedPenisBodyChoiceValue() {
      const btn = getSelectedPenisBodyChoiceButton();
      return btn ? btn.dataset.value || "" : "";
    }

    function renderPenisBodyChoices() {
      if (!penisBodyChoiceButtons) return;

      const previousValue = getSelectedPenisBodyChoiceValue();
      penisBodyChoiceButtons.innerHTML = "";

      const selectedMainSwatches = getSelectedSwatches(mainBodySet);

      selectedMainSwatches.forEach((sw, index) => {
        const name = getSwatchName(sw);
        const btn = document.createElement("button");
        btn.type = "button";
        btn.className = "option-btn";
        btn.dataset.value = name;
        btn.dataset.sourceIndex = String(index);
        btn.setAttribute("aria-pressed", "false");
        btn.innerHTML = `<span class="option-text">${strings.colour_label || "Colour"} ${index + 1} — ${name}</span>`;

        if (name === previousValue) {
          btn.classList.add("active");
          btn.setAttribute("aria-pressed", "true");
        }

        btn.addEventListener("click", function () {
          penisBodyChoiceButtons.querySelectorAll(".option-btn").forEach(b => {
            b.classList.remove("active");
            b.setAttribute("aria-pressed", "false");
          });

          this.classList.add("active");
          this.setAttribute("aria-pressed", "true");

          updatePreview();
          updateInstruction();
          validate();
        });

        penisBodyChoiceButtons.appendChild(btn);
      });
    }

    function updateVariantId() {
      const selected = getSelectedVariantOptions();
      if (!allVariantOptionsChosen(selected)) {
        hiddenInput.value = "";
        return;
      }
      const match = findMatchingVariantExact(selected);
      hiddenInput.value = match ? match.id : "";
    }

    function updateUpgradeFlow() {
      const bodyDone = mainBodyDone();
      const mainSelectedCount = getSelectedSwatches(mainBodySet).length;

      if (previewFrame) {
        previewFrame.style.display = mainSelectedCount > 0 ? "" : "none";
      }

      penisOptionFrame.style.display = bodyDone ? "" : "none";

      const penisOptionChosen = !!getActiveOptionValue("penis-option");
      const penisOptionYes = getActiveOptionValue("penis-option") === "yes";

      if (!bodyDone) {
        penisSet.style.display = "none";
        penisBodyChoiceFrame.style.display = "none";

        form.querySelectorAll('.option-btn[data-option-kind="penis-option"]').forEach(btn => {
          btn.classList.remove("active");
          btn.setAttribute("aria-pressed", "false");
        });

        clearSwatchSet(penisSet);
        clearPenisBodyChoice();

        propPenisOption.value = "";
        propPenisColour.value = "";
        hiddenInput.value = "";
        return;
      }

      penisSet.style.display = penisOptionYes ? "" : "none";
      if (!penisOptionYes) {
        clearSwatchSet(penisSet);
      }

      penisBodyChoiceFrame.style.display = penisOptionChosen && !penisOptionYes ? "" : "none";
      if (penisOptionChosen && !penisOptionYes) {
        renderPenisBodyChoices();
      } else {
        clearPenisBodyChoice();
      }

      propPenisOption.value = getActiveOptionValue("penis-option") || "";
    }

function updatePriceDisplay() {
  const selected = getSelectedVariantOptions();
  const allChosen = allVariantOptionsChosen(selected);

  const fallbackVariant = variants.reduce((lowest, current) => {
    return Number(current.price) < Number(lowest.price) ? current : lowest;
  }, variants[0]);

  const match = allChosen ? findMatchingVariantExact(selected) : fallbackVariant;

  if (!match) {
    priceEl.textContent = "";
    return;
  }

  if (
    match.formatted_compare_at_price &&
    Number(match.compare_at_price) > Number(match.price)
  ) {
    priceEl.innerHTML = `
      <span class="price--compare"><s>${match.formatted_compare_at_price}</s></span>
      <span class="price--sale">${match.formatted_price}</span>
    `;
  } else {
    priceEl.textContent = match.formatted_price;
  }
}

    function updatePreview() {
      if (!previewEl) return;

      previewEl.innerHTML = "";
      const frag = document.createDocumentFragment();

      function makePreviewClickable(wrapper, targetEl, exactSwatch) {
  wrapper.style.cursor = "pointer";

  wrapper.addEventListener("click", () => {
    if (!targetEl) return;

    if (window.expandSwatchSet && targetEl.classList.contains("swatch-set")) {
      window.expandSwatchSet(targetEl);
    }

    const scrollTarget = exactSwatch || targetEl;

    scrollTarget.scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "center"
    });
  });
}

      const mainSwatches = Array.from(mainBodySet.querySelectorAll(".swatch.active"));
      const penisOptionValue = getActiveOptionValue("penis-option");
      let penisPreviewImg = null;
      let penisPreviewName = "";
      let penisPreviewTarget = "penis";

      if (penisOptionValue === "yes") {
        const img = penisSet.querySelector(".swatch.active img");
        if (img) {
          penisPreviewImg = img.cloneNode(true);
          penisPreviewName = img.alt || "";
          penisPreviewTarget = "penis";
        }
      }

      if (penisOptionValue === "no") {
        const selectedBtn = getSelectedPenisBodyChoiceButton();
        const sourceIndex = selectedBtn ? Number(selectedBtn.dataset.sourceIndex) : -1;
        const selectedMainSwatches = getSelectedSwatches(mainBodySet);
        const sourceSwatch = selectedMainSwatches[sourceIndex];
        const sourceImg = sourceSwatch ? sourceSwatch.querySelector("img") : null;

        if (sourceImg) {
          penisPreviewImg = sourceImg.cloneNode(true);
          penisPreviewName = selectedBtn.dataset.value || "";
          penisPreviewTarget = "penis-body";
        }
      }

      if (!mainSwatches.length && !penisPreviewImg) {
        const placeholder = document.createElement("div");
        placeholder.className = "preview-swatch";
        placeholder.setAttribute("data-label", "");
        placeholder.innerHTML = `
          <img
            src="${config.placeholderUrl}"
            alt="${config.placeholderAlt}">
        `;
        frag.appendChild(placeholder);
        previewEl.appendChild(frag);
        return;
      }

      mainSwatches.forEach((sw, index) => {
  const img = sw.querySelector("img");
  if (!img) return;

  const wrapper = document.createElement("div");
  wrapper.className = "preview-swatch";
  wrapper.setAttribute("data-label", `${strings.colour_label || "Colour"} ${index + 1}`);

  const clone = img.cloneNode(true);
  wrapper.appendChild(clone);

  const colourName = img.alt || "";
  if (colourName) {
    const nameTag = document.createElement("span");
    nameTag.className = "preview-colour-name";
    nameTag.textContent = colourName;
    wrapper.appendChild(nameTag);
  }

  makePreviewClickable(wrapper, mainBodySet, sw);
  frag.appendChild(wrapper);
});

      if (penisPreviewImg) {
        const wrapper = document.createElement("div");
        wrapper.className = "preview-swatch";
        wrapper.setAttribute("data-preview-target", penisPreviewTarget);
        wrapper.setAttribute("data-label", strings.preview_penis || "Penis");

        wrapper.appendChild(penisPreviewImg);

        if (penisPreviewName) {
          const nameTag = document.createElement("span");
          nameTag.className = "preview-colour-name";
          nameTag.textContent = penisPreviewName;
          wrapper.appendChild(nameTag);
        }

        makePreviewClickable(
  wrapper,
  penisPreviewTarget === "penis" ? penisSet : penisBodyChoiceFrame,
  null
);
        frag.appendChild(wrapper);
      }

      previewEl.appendChild(frag);
    }

    function updateInstruction() {
      const bodyDone = mainBodyDone();
      const penisOptionValue = getActiveOptionValue("penis-option");
      const penisBodyChoice = getSelectedPenisBodyChoiceValue();
      const penisSwatch = getSelectedSwatches(penisSet).map(getSwatchName);

      if (!bodyDone) {
        instructionEl.textContent = strings.selection_hint_ass_start || "Choose the 3 main body colours first.";
        return;
      }

      if (!penisOptionValue) {
        instructionEl.textContent = strings.selection_hint_ass_upgrade || "Now choose the penis option and required colour.";
        return;
      }

      if (penisOptionValue === "yes" && penisSwatch.length !== 1) {
        instructionEl.textContent = strings.selection_hint_ass_upgrade || "Now choose the penis option and required colour.";
        return;
      }

      if (penisOptionValue === "no" && !penisBodyChoice) {
        instructionEl.textContent = strings.selection_hint_ass_upgrade || "Now choose the penis option and required colour.";
        return;
      }

      instructionEl.textContent = strings.selection_hint_ass_upgrade || "Now choose the penis option and required colour.";
    }

    function validate() {
  const selected = getSelectedVariantOptions();
  const variantsChosen = allVariantOptionsChosen(selected) && !!hiddenInput.value;

  const penisOptionValue = getActiveOptionValue("penis-option");
  const mainBody = getSelectedSwatches(mainBodySet).map(getSwatchName);
  const penisSwatch = getSelectedSwatches(penisSet).map(getSwatchName);
  const penisBodyChoice = getSelectedPenisBodyChoiceValue();

  propC1.value = mainBody[0] || "";
  propC2.value = mainBody[1] || "";
  propC3.value = mainBody[2] || "";

  if (penisOptionValue === "yes") {
    propPenisColour.value = penisSwatch[0] || "";
  } else if (penisOptionValue === "no") {
    propPenisColour.value = penisBodyChoice || "";
  } else {
    propPenisColour.value = "";
  }

  const mainOk = mainBody.length === 3;
  const penisColourOk =
    penisOptionValue === "yes" ? penisSwatch.length === 1
    : penisOptionValue === "no" ? !!penisBodyChoice
    : false;

  const ok = mainOk && variantsChosen && penisColourOk;

  addToCartBtn.disabled = !ok;

  if (ok) {
    setCartVisibility(true);
  } else if (!mainOk) {
    setCartVisibility(
      false,
      strings.validation_choose_main_colours_first || "Choose the 3 main body colours first."
    );
  } else if (!variantsChosen) {
    setCartVisibility(
      false,
      strings.validation_choose_variant_ass || "Choose the penis option first."
    );
  } else {
    setCartVisibility(
      false,
      strings.validation_complete_ass_colours || "Complete the penis colour selection."
    );
  }

  if (instructionEl) {
    instructionEl.style.display = ok ? "none" : "";
  }

  updatePreview();
  updateInstruction();
}

    optionBtns.forEach(btn => {
      btn.addEventListener("click", function () {
        const kind = this.dataset.optionKind;

        form.querySelectorAll(`.option-btn[data-option-kind="${kind}"]`).forEach(b => {
          b.classList.remove("active");
          b.setAttribute("aria-pressed", "false");
        });

        this.classList.add("active");
        this.setAttribute("aria-pressed", "true");

        updateUpgradeFlow();
        updateVariantId();
        updatePriceDisplay();
        validate();
      });
    });

    [mainBodySet, penisSet].forEach(setEl => {
      setEl.addEventListener("click", function (e) {
        const sw = e.target.closest(".swatch");
        if (!sw) return;

        const max = parseInt(setEl.dataset.maxSelect || "1", 10);

        if (sw.classList.contains("active")) {
          sw.classList.remove("active");
          sw.setAttribute("aria-pressed", "false");
        } else {
          if (max === 1) {
            setEl.querySelectorAll(".swatch.active").forEach(s => {
              s.classList.remove("active");
              s.setAttribute("aria-pressed", "false");
            });
          }

          if (setEl.querySelectorAll(".swatch.active").length < max) {
            sw.classList.add("active");
            sw.setAttribute("aria-pressed", "true");
          }
        }

        updateUpgradeFlow();
        updateVariantId();
        updatePriceDisplay();
        validate();

        const chosen = setEl.querySelectorAll(".swatch.active").length;

        if (chosen >= max && window.collapseSwatchSet) {
          setTimeout(() => window.collapseSwatchSet(setEl), 300);
        }

        setTimeout(() => {
          const btn = setEl.querySelector(".show-more-swatches");
          if (btn) {
            btn.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }, 500);
      });
    });

    /* =========================
       SHOW / HIDE COLOURS
    ========================= */
    function getClampTarget(setEl) {
      return setEl.querySelector(".swatch-master-frame")
        || setEl.querySelector(".swatch-groups")
        || setEl.querySelector(".sub-swatch-row")
        || setEl.querySelector(".swatch-row");
    }

    function wireShowHide(setEl) {
      if (setEl.dataset.showMoreBound === "1") return;

      const target = getClampTarget(setEl);
      if (!target) return;

      const wrap = document.createElement("div");
      wrap.className = "clamp-wrap";
      target.parentNode.insertBefore(wrap, target);
      wrap.appendChild(target);

      const btnShow = document.createElement("button");
      btnShow.type = "button";
      btnShow.className = "show-more-swatches";
      btnShow.setAttribute("aria-expanded", "false");
      btnShow.textContent = strings.show_colours || "Show colours ▾";

      const btnHideTop = document.createElement("button");
      btnHideTop.type = "button";
      btnHideTop.className = "show-more-swatches";
      btnHideTop.textContent = strings.hide_colours || "Hide colours ▴";

      const btnHideBottom = btnHideTop.cloneNode(true);

      wrap.before(btnShow);
      wrap.before(btnHideTop);
      wrap.after(btnHideBottom);

      function setExpanded(expanded) {
        wrap.classList.toggle("expanded", expanded);
        btnShow.style.display = expanded ? "none" : "block";
        btnHideTop.style.display = expanded ? "block" : "none";
        btnHideBottom.style.display = expanded ? "block" : "none";
        btnShow.setAttribute("aria-expanded", expanded ? "true" : "false");
      }

      setExpanded(false);

      btnShow.addEventListener("click", () => setExpanded(true));
      btnHideTop.addEventListener("click", () => setExpanded(false));
      btnHideBottom.addEventListener("click", () => setExpanded(false));

      setEl._lsClamp = { setExpanded, wrap, btnShow, btnHideTop, btnHideBottom };
      setEl.dataset.showMoreBound = "1";
    }

    window.collapseSwatchSet = (setEl) => {
      if (setEl && setEl._lsClamp) setEl._lsClamp.setExpanded(false);
    };

    window.expandSwatchSet = (setEl) => {
      if (setEl && setEl._lsClamp) setEl._lsClamp.setExpanded(true);
    };

    setTimeout(() => {
      [mainBodySet, penisSet].forEach(wireShowHide);
    }, 100);

    function loadDeferredInfoMedia(panel) {
      if (!panel) return;

      panel.querySelectorAll("iframe[data-src]").forEach((frame) => {
        if (frame.hasAttribute("src")) return;

        const source = frame.dataset.src;
        if (!source) return;

        frame.src = source;
        frame.removeAttribute("data-src");
      });

      panel.querySelectorAll("video[data-src]").forEach((video) => {
        if (video.hasAttribute("src")) return;

        const source = video.dataset.src;
        if (!source) return;

        video.src = source;
        video.removeAttribute("data-src");
        video.load();
      });
    }

    /* Variant More Information accordion */
    document.addEventListener("click", function(e) {
      const btn = e.target.closest(".variant-more-info-btn");
      if (!btn) return;

      const key = btn.dataset.info;
      const target = document.querySelector(`.variant-more-info-content[data-info-target="${key}"]`);
      if (!target) return;

      const isOpen = target.classList.contains("open");

      document.querySelectorAll(".variant-more-info-content").forEach(section => {
        section.classList.remove("open");
      });

      document.querySelectorAll(".variant-more-info-btn").forEach(b => {
        b.textContent = strings.show_examples || "Show examples";
        b.setAttribute("aria-expanded", "false");
      });

      if (!isOpen) {
        target.classList.add("open");
        loadDeferredInfoMedia(target);
        btn.textContent = strings.hide_examples || "Hide examples";
        btn.setAttribute("aria-expanded", "true");
      }
    });

    /* =========================
       SHIPPING + SIZE GUIDE TOGGLES
    ========================= */
    const shippingToggle = document.querySelector(`#MainProduct-${config.sectionId} .shipping-toggle:not(.size-guide-toggle)`);
    const shippingContent = document.getElementById(`shipping-content-${config.sectionId}`);

    if (shippingToggle && shippingContent) {
      shippingToggle.addEventListener("click", () => {
        const isOpen = shippingToggle.getAttribute("aria-expanded") === "true";
        shippingToggle.setAttribute("aria-expanded", !isOpen);
        shippingContent.classList.toggle("open", !isOpen);
      });
    }
    /* =========================
       INIT
    ========================= */
    updateUpgradeFlow();
    updateVariantId();
    updatePriceDisplay();
    validate();
  });
})();
